// library
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Icon, Label } from "semantic-ui-react";
import { map, filter, maxBy, isEmpty, isArray, isString, trim } from "lodash";
import { arrayMove } from "react-sortable-hoc";

// Modals
import ConfirmModalWrapper from "./ConfirmModalWrapper";
import RenderStage from "./SortableStagesList";

// Styles
import styles from "./styles.module.css";

const StageOptionsComponent = ({
	stages,
	setStages,
	errors,
	images,
	setImages,
	updateStageImage,
	modalOption,
	actionsList,
	warningMinutes,
	timeoutMinutes,
	document,
}) => {
	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const [openOptionConfirmModal, setOpenOptionConfirmModal] = useState(false);
	const [stageIdDelete, setStageIdDelete] = useState(null);
	const [optionIDelete, setOptionIdDelete] = useState(null);
	const [optionOrden, setOptionOrden] = useState();
	const [stageNameDelete, setStageNameDelete] = useState("");

	const getNextId = (item) => {
		const maxItem = maxBy(item, "id");
		return maxItem ? maxItem.id + 1 : 1;
	};

	const addStage = () => {
		setStages([
			...stages,
			{
				id: getNextId(stages),
				order: stages.length + 1,
				name: "",
				text: "",
				type: "Text",
				enlazarStage: null,
				image: [],
				isActive: true,
				buttonLabel: "",
				header: "",
				footer: "",
				options: [{ id: 1, label: "", order: 1, action: "", enlazarStage: "", isOpen: true, isActive: true }],
				isOpen: true,
			},
		]);
	};

	const updateStageName = (id, name, value) => {
		setStages((prevStages) => {
			return map(prevStages, (stage) => {
				return stage.id === id ? { ...stage, [name]: value } : stage;
			});
		});
	};

	const addOptionToStage = (stageId) => {
		setStages((prevStages) => {
			return map(prevStages, (stage) => {
				if (stage.id !== stageId) return stage;

				const nextOptions = [
					...stage.options,
					{
						id: getNextId(stage.options),
						label: "",
						order: stage.options.length + 1,
						action: "",
						enlazarStage: null,
						isOpen: true,
						isActive: true,
					},
				];

				return {
					...stage,
					options: nextOptions,
					type: stage.type === "Button" && nextOptions.length > 3 ? "List" : stage.type,
				};
			});
		});
	};

	// const addOptionToStage = (stageId) => {
	// 	setStages((prevStages) => {
	// 		return map(prevStages, (stage) => {
	// 			return stage.id === stageId
	// 				? {
	// 						...stage,
	// 						options: [
	// 							...stage.options,
	// 							{
	// 								id: getNextId(stage.options),
	// 								label: "",
	// 								order: stage.options.length + 1,
	// 								action: "",
	// 								enlazarStage: null,
	// 								isOpen: true,
	// 								isActive: true,
	// 							},
	// 						],
	// 				  }
	// 				: stage;
	// 		});
	// 	});
	// };

	const updateOption = (stageId, optionId, key, value) => {
		setStages((prevStages) => {
			return map(prevStages, (stage) => {
				return stage.id === stageId
					? {
							...stage,
							options: stage.options.map((option) => {
								return option.id === optionId ? { ...option, [key]: value } : option;
							}),
					  }
					: stage;
			});
		});
	};

	const cancelModal = () => {
		setOpenConfirmModal(false);
	};

	const cancelModalOption = () => {
		setOpenOptionConfirmModal(false);
	};

	const isRemove = (stageId, whatDelete, optionId, ordenOption, stage, option) => {
		switch (whatDelete) {
			case "stage":
				if (stage.name !== "" || stage.text !== "" || stage.enlazarStage !== null) {
					setOpenConfirmModal(true);
					setStageIdDelete(stageId);
					setStageNameDelete(stage.name);
				} else {
					removeStage(stageId);
				}
				break;
			case "option":
				{
					const isOptionFilled =
						!isEmpty(trim(option.label)) ||
						(isArray(option.action) && !isEmpty(option.action)) ||
						(isString(option.action) && !isEmpty(trim(option.action))) ||
						!isEmpty(option.enlazarStage);

					if (isOptionFilled) {
						setStageIdDelete(stageId);
						setOptionIdDelete(optionId);
						setOptionOrden(option.label);
						setOpenOptionConfirmModal(true);
					} else {
						removeOption(stageId, optionId);
					}
				}
				break;

			default:
				break;
		}
	};

	const removeStage = (stageId) => {
		setOpenConfirmModal(false);
		setStages((prevStages) => {
			return filter(prevStages, (stage) => {
				return stage.id !== stageId;
			});
		});
	};

	const removeOption = (stageId, optionId) => {
		setOpenOptionConfirmModal(false);

		setStages((prevStages) => {
			return map(prevStages, (stage) => {
				if (stage.id === stageId) {
					const filteredOptions = filter(stage.options, (option) => {
						return option.id !== optionId;
					});
					const reorderedOptions = filteredOptions.map((option, idx) => {
						return {
							...option,
							order: idx + 1,
						};
					});
					return {
						...stage,
						options: reorderedOptions,
					};
				}
				return stage;
			});
		});
	};

	const onStagesSortEnd = ({ oldIndex, newIndex }) => {
		setStages((prevStages) => {
			const reorderedStages = arrayMove(prevStages, oldIndex, newIndex);
			return map(reorderedStages, (stage, index) => {
				return {
					...stage,
					order: index + 1,
				};
			});
		});
	};

	return (
		<div>
			<RenderStage
				stages={stages}
				setStages={setStages}
				updateOption={updateOption}
				isRemove={isRemove}
				updateStageName={updateStageName}
				addOptionToStage={addOptionToStage}
				helperClass="sortableHelper"
				useDragHandle
				manualSortStage={onStagesSortEnd}
				onSortEnd={onStagesSortEnd}
				errors={errors}
				images={images}
				setImages={setImages}
				updateStageImage={updateStageImage}
				modalOption={modalOption}
				actionsList={actionsList}
				warningMinutes={Number(warningMinutes) || 0}
				timeoutMinutes={Number(timeoutMinutes) || 0}
				document={document}
			/>

			<div className={styles.buttonContainer}>
				<Button primary onClick={addStage} className={styles.addButton} disabled={modalOption === "Watch"}>
					<span className={styles.buttonText}>Agregar Menú</span>
					<Icon name="plus" className={styles.plusIcon} />
				</Button>
				{!isEmpty(errors.stages) && (
					<Label basic color="red" className={styles.errorLabel}>
						{errors.stages}
					</Label>
				)}
			</div>
			<ConfirmModalWrapper
				content="Está seguro que desea eliminar el Menú"
				open={openConfirmModal}
				header="Confirmar Eliminar"
				focus={stageNameDelete}
				onConfirm={() => {
					removeStage(stageIdDelete);
				}}
				onDismiss={cancelModal}
				centerModal
			/>

			<ConfirmModalWrapper
				content="Está seguro que desea eliminar la Opción"
				open={openOptionConfirmModal}
				header="Confirmar Eliminar"
				focus={optionOrden}
				onConfirm={() => {
					removeOption(stageIdDelete, optionIDelete);
				}}
				onDismiss={cancelModalOption}
				centerModal
			/>
		</div>
	);
};

StageOptionsComponent.propTypes = {
	// dispatch: PropTypes.func,
	stages: PropTypes.array,
	setStages: PropTypes.func,
	errors: PropTypes.object,
	images: PropTypes.array,
	setImages: PropTypes.func,
	updateStageImage: PropTypes.func,
	modalOption: PropTypes.string,
	actionsList: PropTypes.object,
	warningMinutes: PropTypes.number,
	timeoutMinutes: PropTypes.number,
	document: PropTypes.string,
};

export default StageOptionsComponent;
